
export const currencyConverter = (exchangeRate, amount) => {
  const rate = parseFloat(exchangeRate)
  return amount / rate
}